import React, { useState, useEffect } from "react";
import HeroSection from "../../components/HeroSection/HeroSection";
import hero_image_5 from "../../assets/images/hero_image_5.jpg";
import Heading from "../../components/Heading/Heading";
import "./Projects.css";
import ProjectCard from "../../components/ProjectCard/ProjectCard";
import { client } from "../../client";
import { fetchAllProjects, fetchProjectCategory } from "../../Utils/data";
import { Helmet } from "react-helmet";

export default function Projects() {
  const [projects, setProjects] = useState([]);
  const [category, setCategory] = useState("all");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    if (category === "all") {
      client.fetch(fetchAllProjects).then((data) => {
        setProjects(data);
        setLoading(false);
      });
    } else {
      const categoryItem = fetchProjectCategory(category);
      client.fetch(categoryItem).then((data) => {
        setProjects(data);
        setLoading(false);
      });
    }
  }, [category]);

  return (
    <div className="project_page">
      <Helmet>
        <title>Projects | Elegro Energy Limited</title>
        <link rel="canonical" href="/projects" />
        <meta name="robots" content="index, follow" />
        <meta
          name="description"
          content="Elegro Energy Limited has worked and is still working on a number of successful projects in supply, installation, commissioning, Route surveying, Line pegging and etc"
        />
      </Helmet>
      <HeroSection
        heroTitle="Turnkey EPC Projects"
        heroParagraph="A highly successful and experienced trading and construction company."
        btnLink="/"
        btnText="Home"
        heroImage={hero_image_5}
      />

      <div className="projects_page container padding_top_bottom">
        <Heading MainHeader="OUR PROJECTS" />
        <div className="subtitle">
          <h2>Turnkey EPC Projects</h2>
          <h2>
            <span>2013 - 2019</span>
          </h2>
        </div>
        <div className="categories row">
          <h2
            onClick={() => setCategory("all")}
            id={category === "all" && "active_category"}
            className="layout-col-md-6 layout-col-lg-3 layout-col-sm-12"
          >
            All Projects
          </h2>
          <h2
            onClick={() => setCategory("on_going")}
            id={category === "on_going" && "active_category"}
            className="layout-col-md-6 layout-col-lg-3 layout-col-sm-12"
          >
            On Going
          </h2>
          <h2
            onClick={() => setCategory("completed")}
            id={category === "completed" && "active_category"}
            className="layout-col-md-6 layout-col-lg-3 layout-col-sm-12"
          >
            Completed
          </h2>
          <h2
            onClick={() => setCategory("supply")}
            id={category === "supply" && "active_category"}
            className="layout-col-md-6 layout-col-lg-3 layout-col-sm-12"
          >
            Supply Projects
          </h2>
        </div>

        <div className="row">
          {loading ? (
            <p className="loading">Loading projects...</p>
          ) : (
            <>
              {projects?.map((project, index) => (
                <ProjectCard key={index} project={project} />
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
